import React, { Fragment } from 'react';
import {
    Typography, Container, TableContainer, Paper, Button,
    Table, TableBody, TableCell, TableHead, TableRow, Link, useTheme
} from '@mui/material';
import parse from 'html-react-parser';
import { Save } from '@mui/icons-material';




export default function AvlParsingResult(props) {
    const theme = useTheme();
    const styles = {
        center: {
            textAlign: 'center',
        },
        table: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: '10px',
        },
        header: {
            backgroundColor: 'rgba(81,81,81,0.5)',
        },
        cell: {
            padding: '2px 20px',
            borderBottom: '1px solid rgba(81,81,81,0.4)',
            borderTop: '1px solid rgba(81,81,81,0.4)',
        },
        container: {
            marginTop: '20px',
        },
        result: {
            fontSize: '1.2rem',
            whiteSpace: 'break-spaces',
        },
        error: {
            color: theme.palette.error.main,
        },
        nowrap: {
            whiteSpace: 'nowrap',
        },
        google: {
            backgroundImage: "url(data:image/jpeg;base64,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)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "24px 24px",
            width: "24px",
            height: "24px",
            display: "block",
            float: "right",
        },
    };

    const data = props.data && (
        props.data.value ||
        props.data.error ||
        { message: props.data.statusText || 'Unknown error occurred' }
    );

    function createData(index, { name, size, value, hex, children }) {
        return [{ name, size, value, hex, children, index: index }].concat(
            (children || []).map((x) => createData(index + 1, x))
        );
    }

    const rows = props.data && props.data.value ? createData(0, props.data.value) : [];

    const saveToFile = () => {
        var data = JSON.stringify(props.data.value, null, 5);
        const mimeType = 'application/json';
        const element = document.createElement("a");
        const file = new Blob([data], { type: `${mimeType};charset=utf-8` });
        element.href = URL.createObjectURL(file);
        element.download = `AVL ${props.tcp ? 'TCP' : 'UDP'}data packet.json`;
        document.body.appendChild(element);
        element.click();
    }

    const mapLink = (row) => {
        if (row.name !== "GPS Element") {
            return null;
        }

        var lat = parseInt(row.children.find(x => x.name === "Latitude")?.value ?? "0", 10);
        var lon = parseInt(row.children.find(x => x.name === "Longitude")?.value ?? "0", 10);

        if (lat === 0 && lon === 0) {
            return null;
        }

        return (
            <Link sx={{ ...styles.google }}
                title="Show on Google Maps"
                href={`https://www.google.com/maps/place/${(lat / 10000000.0).toFixed(7)},${(lon / 10000000.0).toFixed(7)}`}
                target="_blank"
                rel="noopener noreferrer">
            </Link>);
    }

    const resultContent = () => {
        return props.data && props.data.value ?
            <Fragment>
                <Button variant="outlined"
                    sx={{ float: 'right' }}
                    color="primary"
                    title="Save text to file"
                    onClick={saveToFile}>
                    <Save />
                    Save to file
                </Button>
                <TableContainer component={Paper}>
                    <Table sx={{ ...styles.table }} aria-label="simple table">
                        <TableHead>
                            <TableRow sx={{ ...styles.header }}>
                                <TableCell sx={{ ...styles.cell }} align="center">Name</TableCell>
                                <TableCell sx={{ ...styles.cell }} align="center">Size</TableCell>
                                <TableCell sx={{ ...styles.cell }} align="center">Value</TableCell>
                                {<TableCell sx={{ ...styles.cell }} align="center">Hex</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.flat(10000).map((row, i) => {

                                return (
                                    <TableRow key={i}>
                                        <TableCell align="left" sx={{ ...styles.nowrap, ...styles.cell }}>
                                            {parse('<span style="opacity:0.2;line-height: 25px;">' + new Array(row.index + 1).join('|&emsp;') + '</span>')}
                                            {row.name}
                                            {mapLink(row)}
                                        </TableCell>
                                        <TableCell sx={{ ...styles.cell }} align="center">{row.size}</TableCell>
                                        <TableCell sx={{ ...styles.cell }} align="right">{row.value}</TableCell>
                                        {<TableCell sx={{ ...styles.cell }} align="right">
                                            {row.hex}
                                        </TableCell>}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Fragment>
            : <pre sx={{ ...styles.error }}>{(data && data.message) || (data && data.error && data.error.message) || data}</pre>
    };

    return (
        data ? (
            <Container maxWidth="md" sx={{ ...styles.container }}>
                <Typography variable="h6" sx={{ ...styles.center }}>
                    PARSING RESULTS
                </Typography>
                {resultContent()}
            </Container>

        ) : null
    );
}


